import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { axiosInstance } from 'hooks/auth/AxiosInstance';
import { FineRecallPayload, FineRecallResponse } from 'utils/types';

const recallFine = async (
  data: FineRecallPayload,
): Promise<FineRecallResponse> => {
  const endpoint =
    'ticketNumbers' in data && data.ticketNumbers?.length
      ? 'fine/recall/batch'
      : 'fine/recall';

  const response: AxiosResponse<FineRecallResponse> = await axiosInstance.post(
    endpoint,
    data,
  );
  return response.data;
};

const useRecallFine = (): UseMutationResult<
  FineRecallResponse,
  Error,
  FineRecallPayload
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: recallFine,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fine'] });
      queryClient.invalidateQueries({ queryKey: ['fines'] });
      queryClient.invalidateQueries({ queryKey: ['officer-pending-cases'] });
      queryClient.invalidateQueries({
        queryKey: ['case-checker-pending-cases'],
      });
    },
    onError: (error: Error) => {
      console.error('Error recalling fine:', error.message);
    },
  });
};

export default useRecallFine;
